import { Component } from '@angular/core';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { Filter, GenericSmartListFilter } from '@components/smart-list/GenericSmartList';
import { PointTransactionType } from '@models/Enums';


export class SmartListTransactionFilterSelected extends Filter {

    public constructor(init?: Partial<Pick<SmartListTransactionFilterSelected, keyof SmartListTransactionFilterSelected>>) {
        super();

        if (init) {
            Object.assign(this, init);
        }
    }

    selectedType: PointTransactionType;
}

@Component({
    selector: 'app-smart-list-user-transaction-filter',
    templateUrl: './smart-list-user-transaction-filter.component.html',
    styleUrls: ['./smart-list-user-transaction-filter.component.scss']
})
export class SmartListUserTransactionFilterComponent extends GenericSmartListFilter<SmartListTransactionFilterSelected> {

    constructor(public modalService: NgbModal) {
        super(modalService);

        this.selected = new SmartListTransactionFilterSelected({
            selectedType: PointTransactionType.All
        });
    }
}
